import { Team__Nogaleras } from "../teams/Nogaleras";
import { Team__NogalerasJR } from "../teams/NogalerasJR";
import { Team__Panthers } from "../teams/Panthers";
import { Team__Raptors } from "../teams/Raptors";

const Panthers = {
  team: Team__Panthers,
  playingPlayers: [],

  goals: 16,
  penaltyGoals: 0,
  isWinner: false,
};

const NogalerasJR = {
  team: Team__NogalerasJR,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Raptors = {
  team: Team__Raptors,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleras = {
  team: Team__Nogaleras,
  playingPlayers: [],

  goals: 28,
  penaltyGoals: 0,
  isWinner: false,
};

const PLACEMENT_1 = {
  team: {
    name: "Finalista",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: "#ffffff",
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const PLACEMENT_2 = {
  team: {
    name: "Finalista 2",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: "#ffffff",
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada6 = {
  jornadaPosition: 6,
  matches: [
    {
      team1: Panthers,
      team2: Nogaleras,

      isCompleted: true,
      isPlaying: false,
      day: "Sabado",
      date: "2024-08-03",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
